import client from './main-client';

export const getStatesApi = (params) => client()
  .get('/state-province', { params });
